export const titles: Record<string, string> = {

  // Welcome
  '': 'Übersicht',

  // Auth
  'auth': 'Authentifizierung',
  'auth-login': 'Anmeldung',
  'auth-logout': 'Abmelden',
  'auth-can-not-login': 'Anmeldung nicht möglich',
  'set-password': 'Passwort festlegen',

  // Artikel
  'articles': 'Artikel',
  'lagerbestand': 'Lagerbestand',
  'ean': 'EAN',
  'mhd': 'Mindesthaltbarkeit',
  'labels-printer': 'Etikettendrucker',
  'non-product-labels': 'Non-Produkt Etiketten',
  'recipe-cards-printer': 'Rezeptkartendrucker',

  // Logistik
  'orders-open': 'Offen',
  'orders-closed-today': 'Heute fertiggestellt',
  'orders-ship': 'Bestellung versenden',
  'complaints': 'Bestellung / Reklamation',
  'inventory': 'Inventur',
  'slns': 'Lagerplätze',
  'red-list': 'Red List',

  // Warentransfer
  'flour-transfers-munich': 'Warentransfer München',
  'flour-transfers-nuremberg': 'Warentransfer Nürnberg',
  'flour-transfers-hechendorf': 'Warentransfer Hechendorf',
  'flour-transfers-salzburg': 'Warentransfer Salzburg',
  'flour-transfers-munster': 'Warentransfer Münster',
  'flour-transfers-wien': 'Warentransfer Wien',
  'flour-store': 'Warentransfer',
  'stock-transfer': 'Umlagerungen',
  'mhd-offers': 'MHD Angebote',

  // Bulk container / Produktion / Einkauf
  'bulk-containers': 'Großgebinde',
  'bulk-containers-overview': 'Großgebinde',
  'bulk-containers-orders': 'Bestellungen',
  'bulk-containers-orders-Bagable': 'Bestellungen - Eigenmarke',
  'bulk-containers-orders-NonPacking': 'Bestellungen - Fremdmarke',
  'bulk-containers-orders-MIXED': 'Bestellungen',
  'bulk-containers-bulk-container-articles': 'Großgebinde',
  'bulk-containers-bulk-container-non-packing': 'Fremdmarke',
  'bulk-containers-non-packing': 'Fremdmarke',
  'storestocks': 'Übersicht',
  'planning-production': 'Produktions-/Bestellplanung',
  'own-production': 'Mischungen',
  'giftbox-production': 'Geschenkboxen produzieren',
  'production-orders': 'Produktionsaufträge',

  // Production planning
  'production-planning-grundstoffe': 'Grundstoffe',
  'production-planning-grundstoffe-bestand': 'Grundstoffe – Bestand',
  'production-planning-grundstoffe-bedarf': 'Grundstoffe – Bedarf',
  'production-planning-grundstoffe-bestellvorschlaege': 'Grundstoffe – Bestellvorschläge',
  'production-planning-grundstoffe-bestellungen': 'Grundstoffe – Bestellungen',
  'production-articles': 'Produktionsartikel',

  // Users / suppliers / cartons
  'users': 'Mitarbeiter',
  'suppliers': 'Lieferanten',
  'etiketten': 'Etiketten',
  'product-setups': 'Neuanlage Artikel',
  'cartons': 'Kartons',

  // Reports
  'reports-flour-review': 'Flour-Übersicht',
  'reports-product-master': 'Artikelstammdaten',
  'reports-carton-consumption': 'Kartonverbrauch',

  // Tools
  'tools-link-shortener': 'Linkverkürzer',
  'tools-exports': 'Exporte',

  // Marketing
  'marketing-email-signature': 'E-Mail-Unterschrift',
  'marketing-vouchers': 'Geschenkgutscheine',
  'posters': 'Plakate',
  'posters-add': 'Neues Plakat erstellen',
  'marketing-recipe-card-finder': 'Rezeptkarten-Finder',

  // Seminare
  'seminars-overview': 'Seminare',
  'seminars-orders': 'Seminarbestellungen',
  'seminars-categories': 'Kategorien',
  'seminars-waiting-room': 'Warteraum',
  'seminars-hechendorf': 'Seminare Hechendorf',
  'seminars-munchen': 'Seminare München',
  'seminars-nurnberg': 'Seminare Nürnberg',
  'seminars-salzburg': 'Seminare Salzburg',
  'seminars-muenster': 'Seminare Münster',

  // Controlling
  'controlling-stocks': 'Bestände',
  'controlling-production': 'Produktion',
  'controlling-bulk-container': 'Grundstoffe',
  'controlling-non-packing': 'Fremdmarke-Inventur',
  'controlling-prices': 'Preise',
  'controlling-costs': 'Kosten',
  'controlling-sales-evaluation': 'Auswertung Verkauf',

  // Läden / Einstellungen
  'store-photos': 'Dateien',
  'settings-general': 'Allgemein',
  'settings-mail': 'E-Mail-Versand',
  'stores': 'Lagerhäuser',
  'mobile-app': 'Mobile App',
};
